import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

export const ContextualHelpBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 0 0px 0;
`
export const ContextMessage = styled.div`
  color: ${themeColor('primaryPurple')};
  font-size: 12px;
  margin-bottom: 8px;
`
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  border: solid 1px ${themeColor('lightPurple')};
  background-color: ${themeColor('offWhite')};
  color: ${themeColor('blackSecondary')};
  margin-bottom: 20px;
`
export const IconCol = styled.div``
export const ContentCol = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex-grow: 0;
`
export const ContentMessage = styled.div`
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 18px;
  letter-spacing: normal;
  text-align: left;
`
export const Footer = styled.div``
